"use client";

import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-white dark:bg-boxdark text-black dark:text-white px-6 py-12">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <div className="max-w-3xl text-justify">
        <p className="mb-4">
          Welcome to LinqOps! Your privacy is important to us. This Privacy
          Policy explains how we collect, use, and protect your personal
          information when you use our platform and Chrome extension.
        </p>

        <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
        <p className="mb-4">
          We collect information you provide directly to us when you sign up
          for an account, use our platform, or communicate with us. This may
          include:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Your name, email address, and phone number</li>
          <li>Business-related data such as delivery operations details</li>
          <li>Data you manually input into our platform for operational insights</li>
        </ul>
        <p className="mb-4">
          If you choose to install our Chrome extension, we may collect
          additional data from the logistics website you access through the
          extension. This data is used solely to provide insights and improve
          your operational efficiency.
        </p>

        <h2 className="text-xl font-semibold mb-2">How We Use Your Information</h2>
        <p className="mb-4">
          We use your information to:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Provide and improve our platform and services</li>
          <li>Generate insights to help you optimize your daily operations</li>
          <li>Communicate with you about updates, support, and new features</li>
          <li>Ensure the security and integrity of our platform</li>
        </ul>

        <h2 className="text-xl font-semibold mb-2">Chrome Extension Permissions</h2>
        <p className="mb-4">
          Our Chrome extension requires permissions to access specific websites
          to fetch data related to your operations. These permissions are
          necessary to provide the functionality of the extension. You can
          choose not to install the extension and still manually input data
          into the platform.
        </p>
        <p className="mb-4">
          The extension does not collect any data beyond what is necessary for
          its functionality, and no data is shared or sold to third parties.
        </p>

        <h2 className="text-xl font-semibold mb-2">Data Security</h2>
        <p className="mb-4">
          We implement industry-standard security measures to protect your data.
          However, no method of transmission over the internet or electronic
          storage is 100% secure. We continuously work to improve our security
          practices to safeguard your information.
        </p>

        <h2 className="text-xl font-semibold mb-2">Your Choices</h2>
        <p className="mb-4">
          You have the right to:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Access, update, or delete your personal information</li>
          <li>Choose whether to install and use the Chrome extension</li>
          <li>Manually input data into the platform if you prefer</li>
        </ul>
        <p className="mb-4">
          To exercise these rights, please contact us at{" "}
          <a href="mailto:support@linqops.com" className="text-primary">
            support@linqops.com
          </a>
          .
        </p>

        <h2 className="text-xl font-semibold mb-2">Data Sharing</h2>
        <p className="mb-4">
          We do not sell, rent, or share your data with third parties. Your
          information is used solely to provide and improve our services.
        </p>

        <h2 className="text-xl font-semibold mb-2">Changes to This Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated revision date. We encourage
          you to review this policy periodically to stay informed about how we
          are protecting your information.
        </p>

        <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy or our practices,
          please contact us at{" "}
          <a href="mailto:support@linqops.com" className="text-primary">
            support@linqops.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;